module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-BD.48babec5.png";